import React, { useEffect, useState } from 'react'
import { FaPlus, FaEdit, FaChevronLeft, FaChevronRight } from 'react-icons/fa'
import Empty from '../feedback/Empty'
import Loading from '../feedback/Loading'
import adminServices from '../../services/AdminServices'
import PropertyModal from '../houses/PropertyModal'
import { Link } from 'react-router-dom'

function HousesTab() {
    const [properties, setProperties] = useState([])
    const [loading, setLoading] = useState(false)
    const [action, setAction] = useState(0)
    const [activeProperty, setActiveProperty] = useState(null)
    const [page, setPage] = useState(1)
    const [hasNext, setHasNext] = useState(false)
    const [hasPrev, setHasPrev] = useState(false)
    const [totalCount, setTotalCount] = useState(0)

    useEffect(() => { fetchProperties(page) }, [page])

    const fetchProperties = (pageNum) => {
        setLoading(true)
        adminServices.adminListProperties(`?page=${pageNum}`)
            .then(res => {
                const data = res.data
                if (data.results) {
                    setProperties(data.results)
                    setTotalCount(data.count)
                    setHasNext(!!data.next)
                    setHasPrev(!!data.previous)
                } else {
                    setProperties(Array.isArray(data) ? data : [])
                    setTotalCount(data.length)
                    setHasNext(false)
                    setHasPrev(false)
                }
            })
            .catch(() => console.error('Fetch failed'))
            .finally(() => setLoading(false))
    }

    const openModal = (type, prop = null) => {
        setAction(type)
        setActiveProperty(prop)
        document.getElementById('property-open-btn')?.click()
    }

    const formatRate = (rate) => rate ? `KES ${Number(rate).toLocaleString()}` : '—'

    return (
        <div className='space-y-5 w-full'>
            <div className="flex justify-between items-center">
                <h3 className='text-xl text-primary font-bold'>
                    Properties{' '}
                    <span className='ml-2 text-on-surface-variant/60 text-base font-normal'>
                        ({totalCount})
                    </span>
                </h3>
                <button onClick={() => openModal(0)} className='btn btn-primary rounded-xl btn-sm gap-2'>
                    <FaPlus /> Add Property
                </button>
            </div>

            <PropertyModal
                action={action}
                activeProperty={activeProperty}
                onReload={() => fetchProperties(page)}
                setActiveProperty={setActiveProperty}
            />

            <div className="bg-white rounded-xl border border-outline-variant/15 overflow-hidden">
                <div className='overflow-x-auto'>
                    <table className="table table-zebra w-full">
                        <thead>
                            <tr>
                                <th>Image</th>
                                <th>Title</th>
                                <th className='hidden md:table-cell'>Category</th>
                                <th className='hidden md:table-cell'>Rate/Night</th>
                                <th className='hidden lg:table-cell'>Beds/Baths</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {properties?.length ? properties.map((p) => (
                                <tr key={p.id}>
                                    <td>
                                        {p.cover_image ? (
                                            <img src={p.cover_image} alt={p.title} className="w-12 h-12 rounded-lg object-cover border border-outline-variant/20" />
                                        ) : (
                                            <div className="w-12 h-12 rounded-lg bg-surface-container flex items-center justify-center text-on-surface-variant/30">
                                                <FaEdit />
                                            </div>
                                        )}
                                    </td>
                                    <td>
                                        <div className="font-semibold text-primary hover:cursor-pointer">
                                            <Link
                                                to={`/house/${p?.slug}`}
                                            >{p.title}</Link>
                                        </div>
                                        <div className="text-xs text-on-surface-variant/60 md:hidden">
                                            {p.category_name} • {formatRate(p.nightly_rate)}
                                        </div>
                                    </td>
                                    <td className='hidden md:table-cell text-sm'>{p.category_name}</td>
                                    <td className='hidden md:table-cell font-medium text-sm'>{formatRate(p.nightly_rate)}</td>
                                    <td className='hidden lg:table-cell text-sm'>{p.bedrooms} / {p.bathrooms}</td>
                                    <td>
                                        <div className="flex gap-2">
                                            <button
                                                onClick={() => openModal(1, p)}
                                                className='btn btn-secondary btn-sm rounded-xl text-white' title="Edit">
                                                <FaEdit /> Edit</button>
                                        </div>
                                    </td>
                                </tr>
                            )) : null}
                        </tbody>
                    </table>

                    {loading && <Loading />}
                    {!properties?.length && !loading && <div className="p-6"><Empty objectName="Properties" /></div>}
                </div>

                {/* Pagination Controls */}
                {properties.length > 0 && (
                    <div className="flex items-center justify-between px-4 py-3 border-t border-outline-variant/10 bg-surface-container-lowest">
                        <p className="text-xs text-on-surface-variant/70">
                            Page {page} {hasNext || hasPrev ? `of ${Math.ceil(totalCount / (totalCount / page || 10))}` : ''}
                        </p>
                        <div className="flex gap-2">
                            <button
                                onClick={() => setPage(p => p - 1)}
                                disabled={!hasPrev || loading}
                                className="btn btn-ghost btn-xs gap-1 disabled:opacity-40"
                            >
                                <FaChevronLeft /> Prev
                            </button>
                            <button
                                onClick={() => setPage(p => p + 1)}
                                disabled={!hasNext || loading}
                                className="btn btn-ghost btn-xs gap-1 disabled:opacity-40"
                            >
                                Next <FaChevronRight />
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}
export default HousesTab